import { getPaginationItemKind, getVisibleItems } from './pagination-logic';

export const withLogic =
  (Component: React.ComponentType<any>): React.FC<any> =>
  (props: any) => {
    const { selectedIndex = 0, count, kind } = props;

    const visibleItems = getVisibleItems(selectedIndex, count);

    const items = Array.from({ length: count }).map((_, index) => {
      const itemKind = getPaginationItemKind(
        index,
        count > 7 ? 'diminishing' : 'normal',
        visibleItems,
        selectedIndex,
        count
      );
      const isHidden = count > 7 && !visibleItems.includes(index);
      return {
        active: selectedIndex === index,
        kind: itemKind,
        internalClasses: [isHidden ? 'hide' : ''].join(' ')
      };
    });

    return (
      <div
        style={{
          position: 'relative'
        }}
      >
        <Component {...{ ...props, items }} />
      </div>
    );
  };
